import React, { useMemo } from "react";
import { RankingFichaSetoresViewProps } from "../types";
import { Header } from "./Header";
import { NavigationButtons } from "../../Producao/components/NavigationButtons";
import { LojaSelector } from "../../Producao/components/LojaSelector";
import { EmptyState } from "./EmptyState";
import { GeralProgressBanner } from "./GeralProgressBanner";
import { SetorProgressCard } from "./SetorProgressCard";
import { useRankingFichaTvAutoScroll } from "../../FichaDiaria/hooks/useRankingFichaTvAutoScroll";

export const RankingFichaSetoresView: React.FC<RankingFichaSetoresViewProps> = ({
  lojasTv = [],
  geral,
  conferencia,
  producaoTotal,
  lojas = [],
  selectedLojaId,
  showLojaSelector = false,
  dateLabel,
  selectedLojaNome,
  onGoHome,
  onToggleLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  const variasLojas = lojasTv.length > 1;
  const setoresCount = lojasTv.reduce((acc, l) => acc + l.setores.length, 0);
  const fingerprint = useMemo(
    () =>
      lojasTv
        .map(
          (loja) =>
            `${loja.lojaId}:${loja.geral.pct}:${loja.conferencia?.assinado ? "1" : "0"}:${loja.producaoTotal?.assinado ? "1" : "0"}:${loja.setores
              .map(
                (s) =>
                  `${s.setorId}-${s.pct}-${s.producao.assinado ? "1" : "0"}`
              )
              .join(",")}`
        )
        .join("|"),
    [lojasTv]
  );
  const { listaRef } = useRankingFichaTvAutoScroll(setoresCount, fingerprint);

  return (
    <div className="relative flex h-screen flex-col overflow-hidden bg-red-900 text-white">
      <NavigationButtons
        lojasCount={lojas.length}
        onGoHome={onGoHome}
        onToggleLojaSelector={onToggleLojaSelector}
      />

      <LojaSelector
        lojas={lojas}
        selectedLojaId={selectedLojaId}
        showLojaSelector={showLojaSelector}
        onSelectAllLojas={onSelectAllLojas}
        onSelectLoja={onSelectLoja}
      />

      <Header
        dateLabel={dateLabel}
        selectedLojaId={selectedLojaId}
        selectedLojaNome={selectedLojaNome}
      />

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-3 pb-4 pt-1 sm:px-6">
        <div className="mx-auto flex h-full min-h-0 w-full max-w-7xl flex-1 flex-col gap-3 overflow-hidden">
          <GeralProgressBanner
            geral={geral}
            conferencia={variasLojas ? null : conferencia}
            producaoTotal={variasLojas ? null : producaoTotal}
            titulo={
              variasLojas
                ? "Geral de todas as lojas"
                : "Geral de todos os setores"
            }
          />

          {setoresCount === 0 ? (
            <EmptyState />
          ) : (
            <div
              ref={listaRef}
              className="min-h-0 flex-1 overflow-y-auto pr-1"
            >
              <div className="space-y-6">
                {lojasTv.map((loja) => (
                  <section key={loja.lojaId}>
                    {variasLojas ? (
                      <div className="mb-3">
                        <h2 className="mb-2 text-xl font-black uppercase tracking-wide text-yellow-200 sm:text-2xl">
                          {loja.lojaNome}
                        </h2>
                        <GeralProgressBanner
                          geral={loja.geral}
                          conferencia={loja.conferencia}
                          producaoTotal={loja.producaoTotal}
                          titulo="Geral da loja"
                        />
                      </div>
                    ) : null}
                    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                      {loja.setores.map((setor) => (
                        <SetorProgressCard key={setor.setorId} setor={setor} />
                      ))}
                    </div>
                  </section>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
